<script>
/* Making things play nicely with vue2-leafet + the CovJSON leaflet plugins
   is more trouble than it's worth.  We use Vue for the reactive properties,
   but all Leaflet interaction is done in the traditional way */
import { mapState } from 'vuex'
import { findRealParent } from 'vue2-leaflet'
import * as C from 'leaflet-coverage'

export default {
	name: 'LCovJSON',
	render(h) {
		/* Empty render function, since all attaching is done in mounted() */
		return h()
	},
	computed: {
		...mapState(['selectedEvent', 'selectedFeature', 'selectedFeatureIndex'])
	},
	props: {
		parameter: {
			type: String,
			required: true
		},
		opacity: {
			type: Number,
			default: 1.0
		},
		covjson: {
			type: Object | null,
			required: true
		},
		scale: {
			type: Array,
			required: true
		},
		palette: {
			type: Object,
			required: true
		},
		time: {
			type: Date,
			required: false
		}
	},
	data() {
		return {
			map: null,
			parentContainer: null,
			covJsonLayer: null
		}
	},
	async mounted() {
		// Grab the relevant map object
		this.parentContainer = findRealParent(this.$parent)
		this.map = this.parentContainer.mapObject

		this.addCovJsonLayer()
	},
	beforeDestroy() {
		if (this.covJsonLayer) {
			this.map.removeLayer(this.covJsonLayer)
		}
	},
	watch: {
		covjson(){
			this.addCovJsonLayer()
		},
		selectedEvent() {
			this.addCovJsonLayer()
		},
		time() {
			if(!this.covJsonLayer) return
			this.$store.commit('SET_LOADING')
			this.covJsonLayer.time = this.time
			this.$store.commit('SET_FINISHED_LOADING')
		}
	},
	methods: {
		async addCovJsonLayer() {
			if(this.covjson == null) {
				return
			}
			this.$store.commit('SET_LOADING')
			try {
				if (this.covJsonLayer) {
					this.map.removeLayer(this.covJsonLayer)
				}

				this.covJsonLayer = C.dataLayer(this.covjson, {
					parameter: this.parameter,
					paletteExtent: this.scale,
					palette: this.palette,
					extendMax: true,
					extendMin: true,
					time: this.time,
					opacity: this.opacity
				}).on('afterAdd', () => {
					this.$store.commit('SET_FINISHED_LOADING')
				})
				this.covJsonLayer.addTo(this.map)
			} catch (error) {
				console.warn(error)
			}
		}
	}
}
</script>

<style lang="scss"></style>
